import { useCallback } from 'react';

import { useTracking } from '@change-corgi/core-react/tracking';

import { useSearchActions } from '#src/app/pages/searchV2/shared/searchState';

type Result = ModelHookResult<
	undefined,
	{
		filterByTrending: () => void;
	}
>;

export function useFilterByTrending(): Result {
	const actions = useSearchActions();
	const track = useTracking();

	return {
		actions: {
			filterByTrending: useCallback(() => {
				void track('search', { q: '', context: 'landing_trending_button' });
				actions.setStatus('trending');
			}, [actions, track]),
		},
	};
}
